import { IconProps } from '@euler/app/components/icons/types';
import { Typography } from '@euler/app/components/typography';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { Center } from '@euler/components/Center';
import { Colors } from '@euler/components/Colors';
import { Img } from '@euler/components/image/AdvancedImage';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

export const DashboardImageView = memo(
  ({
    dashboardImageUrl,
    style,
    onPress,
  }: {
    dashboardImageUrl?: string;
    style?: StyleProp<ViewStyle>;
    onPress?: () => void;
  }) => {
    const theme = usePresentationTheme();
    const { rpx } = useResponsiveContext();
    return (
      <View style={style}>
        <Typography.Label
          bold
          color={theme.panel.titleTextColor}
          size={rpx(32)}
          css={`
            margin-bottom: ${rpx(20)}px;
          `}
        >
          仪表盘
        </Typography.Label>
        {dashboardImageUrl == null ? (
          <Center
            css={`
              flex: 1;
            `}
          >
            <PlaceholderIcon color={Colors.White1_5} />
          </Center>
        ) : (
          <TouchableOpacity
            onPress={onPress}
            css={`
              flex: 1;
            `}
          >
            <Img
              uri={dashboardImageUrl}
              resizeMode="cover"
              css={`
                flex: 1;
                border-radius: ${rpx(20)}px;
              `}
            />
          </TouchableOpacity>
        )}
      </View>
    );
  },
);

const PlaceholderIcon = memo(({ size = 200, color }: IconProps) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} fill={color}>
      <Path d="M461.65376 676.181333l154.112-135.68a21.333333 21.333333 0 0 1 33.706667 24.490667l-84.48 195.712c-34.133333 32.938667-65.877333 36.48-95.146667 10.581333-29.226667-25.856-31.957333-57.557333-8.149333-95.104z" />
      <Path d="M512.000427 85.333333c282.752 0 512 229.248 512 512 0 124.970667-44.970667 243.072-125.226667 335.488a42.666667 42.666667 0 1 1-64.426667-55.893333A424.789333 424.789333 0 0 0 938.667093 597.333333c0-235.648-191.018667-426.666667-426.666666-426.666666S85.33376 361.685333 85.33376 597.333333c0 101.973333 35.84 198.229333 100.096 274.602667a42.666667 42.666667 0 1 1-65.28 54.954667A510.037333 510.037333 0 0 1 0.000427 597.333333C0.000427 314.581333 229.248427 85.333333 512.000427 85.333333z" />
      <Path d="M512.000427 256a341.333333 341.333333 0 0 1 277.376 540.288 42.666667 42.666667 0 0 1-69.290667-49.792 256 256 0 1 0-415.232 1.28 42.666667 42.666667 0 0 1-68.992 50.218667A341.333333 341.333333 0 0 1 512.000427 256z" />
    </Svg>
  );
});
